import {CSSProperties} from "react";

export enum IconSize {
    xs = 15,
    sm = 20,
    md = 30,
    lg = 40,
    xl = 50,

    bagXl = 100
}

export interface IconProps {
    size: IconSize | number | string
    colour?: string
    style?: CSSProperties
    className?: string
}
